import axios from 'axios';
import { EXERCISE_LIST } from '../../constants';

export const fetchExerciseList = (pageSize, pageNumber, onError) => (dispatch) => {
  dispatch(loadExerciseList());

  axios
    .get(`/admin/listExercises?page_size=${pageSize}&page_number=${pageNumber}`)
    .then((res) => dispatch(setExerciseList(res.data.data)))
    .catch((err) => {
      dispatch(errorExerciseList(err.response));
      onError(err.response);
    });
};

export const loadExerciseList = () => ({
  type: EXERCISE_LIST.LOAD
});

export const setExerciseList = (exerciseList) => ({
  type: EXERCISE_LIST.SUCCESS,
  payload: exerciseList
});

export const errorExerciseList = (error) => ({
  type: EXERCISE_LIST.FAIL,
  payload: error
});
